import type { SVGProps } from 'react';

const SvgNavigationTemplates = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Navigation Templates"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M6.92 7.68h12.1v9.08H6.92zm3.03 3.03v3.03H16v-3.03z"
    />
    <path fill={props.color} d="M6.92 22.81h12.1v-3.03H6.92z" />
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M5.41 30.37c-2.51 0-4.54-2.03-4.54-4.54V6.17c0-2.51 2.03-4.54 4.54-4.54h15.13c2.51 0 4.54 2.03 4.54 4.54h1.51c2.51 0 4.54 2.03 4.54 4.54v15.13c0 2.51-2.03 4.54-4.54 4.54H5.41ZM3.9 6.17c0-.84.68-1.51 1.51-1.51h15.13c.84 0 1.51.68 1.51 1.51v21.18H5.41c-.84 0-1.51-.68-1.51-1.51zm21.18 21.18h1.51c.84 0 1.51-.68 1.51-1.51V10.71c0-.84-.68-1.51-1.51-1.51h-1.51z"
    />
  </svg>
);

export default SvgNavigationTemplates;
